import { UserInfo } from "@/types/AppTypes";
import { Link } from "react-router-dom";

const Footer = ({user}: {user?: UserInfo | null}) => {
  const sections = [
    {
      title: "PALETTE",
      isInfo: true,
      description: "The ultimate marketplace for salon professionals.",
      items: [],
      link: "/",
      
    },
    {
      title: "Shop",
      items: [
        { name: "By Brand", link: "/brands" },
        { name: "By Category", link: "/categories" },
        { name: "Pick Up Locations", link: "#" },
        { name: "Quick Reorder", link: "/quick-reorder" },
      ],
    },
    {
      title: "Account",
      items: [
        { name: "Login", link: "/login" },
        { name: "Register", link: "/login" },
        { name: "Order History", link: "#" },
        { name: "My Account", link: "#" },
      ],
    },
    {
      title: "Contact",
      items: [
        {
          name: "Email: mroseghattas@gmail.com",
          link: "mailto:mroseghattas@gmail.com",
          isEmail: true,
        },
        { name: "Phone: (XXX) XXX-XXXX", link: null },
       
      ],
    },
  ];

  return (
    <footer className={`${user?.current_role !== "seller" ? "bg-black text-[#d1d5db] py-8" : "bg-white text-black py-8 border-t border-gray-300 mt-20"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-6 flex flex-wrap justify-between pb-8">
        {sections.map((section, index) => (
          <div key={index} className="w-full md:w-1/4 mb-6">
            <h2 className={`text-lg font-bold mb-4 ${user?.current_role !== "seller" ? "text-white" : "text-black"}`}><Link to={section.link ? section.link : "#"}>{section.title}</Link></h2>
            {section.isInfo && <p className="leading-relaxed text-sm">{section.description}</p>}
            {section.items.length > 0 && (
              <ul>
                {section.items.map((item, idx) => (
                  <li key={idx} className="mb-3 text-sm">
                    {item.link ? (
                      <Link to={item.link} className="hover:opacity-80">
                        {item.name}
                      </Link>
                    ) : (
                      item.name
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      <div className={`border-t border-gray-300 py-4 px-4 sm:px-6 lg:px-8 text-center text-sm  `}>
        <span  >© 2025 Palette Supply Hub. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
